'use strict';

// https://262.ecma-international.org/15.0/#sec-isbigintelementtype

module.exports = function IsBigIntElementType(type) {
	return type === 'BIGUINT64' || type === 'BIGINT64';
};
